// extracted by mini-css-extract-plugin
module.exports = {"Feature":"Feature_Feature__WV0Op"};